import { render, staticRenderFns } from "./recoder.vue?vue&type=template&id=9977319e&scoped=true&"
import script from "./recoder.vue?vue&type=script&lang=js&"
export * from "./recoder.vue?vue&type=script&lang=js&"
import style0 from "./recoder.vue?vue&type=style&index=0&id=9977319e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9977319e",
  null
  
)

export default component.exports